import { HeartFlashIcon } from './HeartFlashIcon';

/**
 * author: Michael Irigoyen
 * id 9B033C3C-210D-4EFD-AD4E-FF9E36E44509
 * name heart-flash
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-flash.svg
 * tags
 * - Medical / Hospital 
 */
export const AedIcon = HeartFlashIcon;
export default AedIcon